<template>
  <div class="index" style="background: #f5f7fa">
    <header>
      <Navbar />
    </header>
    <div class="home-header">
      <div class="header-banner">
        <div class="top">
          <div class="topText">
            <p>1998<span>年</span></p>
            <p>公司成立时间</p>
          </div>
          <div class="topText">
            <p>5000<span>万</span></p>
            <p>公司注册资金</p>
          </div>
          <div class="topText">
            <p>400<span>余家</span></p>
            <p>服务医疗机构</p>
          </div>
        </div>
      </div>
    </div>
    <div class="productBox">
      <div class="container productTitleIcon">
        <div class="productText">
          <img :src="worldIcon" />
        </div>

        <div class="englishBg">
          <img :src="englishBg" />
        </div>
        <div class="productContentBg">
          <div class="productTitle">科技服务健康</div>
          <div class="productContent">
            <div>
              天津展华科技发展有限公司，是一家专注于医疗行业信息化建设的高科技企业，总部位于天津市和平区合生财富广场，在北京、新疆等地设有分公司。
            </div>
            <div>
              展华科技紧扣时代脉搏，持续走创新发展的道路，已经获得包括HIS、电子病历、集成平台、智慧医疗、综合运营管理、区域医疗等在内的数十项自主知识产权产品国家级认证。
            </div>
          </div>
        </div>
      </div>
      <div class="productContentBox">
        <div
          class="redBoxBacklist"
          v-for="(item, traitIndex) in traitArr"
          :key="traitIndex"
        >
          <div class="redBoxBack">
            <div class="redTitleBox">
              <div class="redline"></div>
              <div class="redTitle">{{ item.title }}</div>
            </div>
            <div class="tecText">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coreProduct">
      <div class="coreProductBg">
        <div class="a">
          <div class="clinical" v-show="page === 1">
            <div class="coreProduct-l">
              <div class="coreProductTitle">
                <div class="whiteLine"></div>
                <div>展华核心产品</div>
              </div>
              <div class="coreProductText">
                <p>公司的主要解决方案和产品系列：</p>
                <div class="coreProductContent">
                  <img :src="ellipse" />
                  <div class="coreProductContentP">临床业务管理类产品</div>
                </div>
                <div class="coreProductContent">
                  <img :src="ellipse" />
                  <div class="coreProductContentP">卫生经济管理类产品</div>
                </div>
              </div>
            </div>
            <div class="coreProduct-c">
              <div class="coreProduct-cTitle" style="margin-top: 41px">
                临床业务
              </div>
              <div class="coreProduct-cTitle">管理类产品</div>
              <div class="redLine"></div>
              <div class="coreProduct-cText">
                HIS、电子病历、集成平台、临床数据中心、临床路径、抗生素管理、智慧护理、智慧门诊、智慧住院、区域医疗平台、云医疗等系统软件。
              </div>
            </div>
            <div class="coreProduct-swiper">
              <img :src="coreProducta" />
              <img :src="coreProductb" />
              <!-- <div class="core-swiper">
              <img style="margin-right: 40px" :src="prevW" />
              <img :src="nextW" />
            </div> -->
            </div>
          </div>
          <div class="health" v-show="page === 2">
            <div class="coreProduct-l">
              <div class="coreProductTitle">
                <div class="whiteLine"></div>
                <div>展华核心产品</div>
              </div>
              <div class="coreProductText">
                <p>公司的主要解决方案和产品系列：</p>
                <div class="coreProductContent">
                  <img :src="ellipse" />
                  <div class="coreProductContentP">临床业务管理类产品</div>
                </div>
                <div class="coreProductContent">
                  <img :src="ellipse" />
                  <div class="coreProductContentP">卫生经济管理类产品</div>
                </div>
              </div>
            </div>
            <div class="coreProduct-c">
              <div class="coreProduct-cTitle" style="margin-top: 41px">
                卫生经济
              </div>
              <div class="coreProduct-cTitle">管理类产品</div>
              <div class="redLine"></div>
              <div class="coreProduct-cText">
                HIS、电子病历、集成平台、临床数据中心、临床路径、抗生素管理、智慧护理、智慧门诊、智慧住院、区域医疗平台、云医疗等系统软件。
              </div>
            </div>
            <div class="coreProduct-swiper">
              <img :src="coreProductb" />
              <img :src="coreProducta" />
            </div>
          </div>
        </div>
        <div class="core-swiper">
          <img @click="tab(1)" style="margin-right: 40px" :src="prevW" />
          <img @click="tab(2)" :src="nextW" />
        </div>
      </div>
    </div>
    <div class="smartBox">
      <div class="smartText">
        <img :src="smart" />
      </div>

      <div class="englishBg">
        <img :src="englishBg" />
      </div>
      <div class="smartContentBg">
        <div class="smartTitle">核心理念</div>
        <div class="smartContent">
          <div>
            展华科技为医疗行业用户提供一系列安全、可靠、高质量、易实施、易扩展的集成化医疗信息产品。
          </div>
        </div>
      </div>
      <div class="smartFooter">
        <div class="smartImg">
          <img :src="smart1" />
          <div>自主知识产权</div>
        </div>
        <div class="smartImg">
          <img :src="smart2" />
          <div>专业软件技术</div>
        </div>
        <div class="smartImg">
          <img :src="smart3" />
          <div>一体化解决方案</div>
        </div>
        <div class="smartImg">
          <img :src="smart4" />
          <div>高质量服务</div>
        </div>
      </div>
    </div>
    <div class="wis">
      <div class="wisBg" style="height: 700px">
        <div class="wisCont">
          <div class="wisContTitle">
            <div class="whiteLine"></div>
            <div>智慧医疗产品体系</div>
            <div class="wisContMore" @click="goProductCenter">
              查看更多
              <img :src="more" />
            </div>
          </div>
          <div class="wisText">
            <div
              class="wisTextList"
              v-for="(item, wisIndex) in wisList"
              :key="wisIndex + 1"
            >
              <div class="wisText-l">
                <div class="wisblock">
                  <div>{{ item.title }}</div>
                  <div>{{ item.text }}</div>
                </div>
                <!-- <div >  -->
                <!-- <div ><img :src="item.progressBar" /></div> -->
                <div class="circle">
                  <img v-show="current === wisIndex" :src="item.circle" />
                  <img v-show="current != wisIndex" :src="item.circleChoose" />
                  <div class="progressBar">
                    <img
                      v-show="current != wisIndex + 1"
                      :src="item.progressBar"
                    />
                    <img
                      v-show="current === wisIndex + 1"
                      :src="item.progressBarChoose"
                    />
                  </div>
                </div>

                <!-- </div> -->
                <div class="downArrow" style="text-alin: center; height: 38px">
                  <img v-show="current === wisIndex" :src="item.downArrow" />
                </div>
                <div class="wisa">
                  <img
                    v-show="current === wisIndex"
                    :src="item.wisR"
                    @click="isActive(wisIndex)"
                  />
                  <img
                    v-show="current != wisIndex"
                    :src="item.wisW"
                    @click="isActive(wisIndex)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="smartBox">
      <div class="smartText">
        <img :src="business" />
      </div>

      <div class="englishBg">
        <img :src="englishBg" />
      </div>
      <div class="smartContentBg">
        <div class="smartTitle">企业资讯</div>
        <div class="smartContent">
          <div>
            展华科技已发展成为集实用创新型软件研究与开发、专业标准化实施与服务于一体的整体解决方案提供商
          </div>
        </div>
      </div>
      <div class="information">
        <div class="information-l">
          <img :src="floor" />
          <div class="information-ltext">
            <div>
              展华科技作为天津市和平区招商引资重点企业，立足天津面向全国
            </div>
            <div>
              公司重新注册于天津市和平区，更名为天津展华科技发展有限公司，立足天津面向全国，持续为全国医疗卫生领域广大用户提供HIS、电子病历、集成平台、综合运营管理、智慧医院、区域医疗等软件产品及技术服务。
            </div>
          </div>
        </div>
        <div class="information-r">
          <div class="companyNews" v-show="newspage === 1">
            <div
              class="information-rlist"
              v-for="(items, newindex) in newArr"
              :key="newindex"
            >
              <div class="information-rtitle">
                <div>公司新闻/{{ items.date }}</div>
              </div>
              <div class="information-rtext">
                {{ items.content }}
              </div>
            </div>
          </div>
          <div class="companyNews" v-show="newspage === 2">
            <div
              class="information-rlist"
              v-for="(items, newindex) in newArr"
              :key="newindex"
            >
              <div class="information-rtitle">
                <div>公司新闻/{{ items.date }}</div>
              </div>
              <div class="information-rtext">
                {{ items.content }}
              </div>
            </div>
          </div>
          <!-- </div> -->
          <div class="information-rfoot">
            <img @click="news(1)" style="margin-right: 40px" :src="prevR" />
            <img @click="news(2)" :src="nextR" />
          </div>
        </div>
      </div>
    </div>

    <div
      class="smartBox"
      style="position: relative; overflow: hidden; background-color: #ffffff"
    >
      <div class="smartText">
        <img :src="heart" />
      </div>
      <div class="mapBg">
        <img :src="map" />
      </div>
      <div class="englishBg" style="position: absolute; top: 140px">
        <img :src="englishBg" />
      </div>
      <div class="smartContentBg">
        <div class="smartTitle">城市与企业合作伙伴</div>
        <div class="smartContent">
          <div>
            展华科技以医疗行业用户获得最佳的产品应用体验和持续发展为己任，力争创造客户、社会价值的最大化
          </div>
        </div>
      </div>
    </div>
    <footer>
      <Root />
    </footer>
  </div>
</template>

<script>
import Navbar from "../../layout/Navbar.vue";
import Root from "../../layout/root.vue";
import logo from "../../assets/logo.png";
import banner from "../../assets/banner.png";
import worldIcon from "../../assets/worldIcon.png";
import englishBg from "../../assets/englishBg.png";
import productBg from "../../assets/productBg.png";
import ellipse from "../../assets/ellipse.png";
import coreProducta from "../../assets/coreProducta.png";
import coreProductb from "../../assets/coreProductb.png";
import smart from "../../assets/smart.png";
import smart1 from "../../assets/smart1.png";
import smart2 from "../../assets/smart2.png";
import smart3 from "../../assets/smart3.png";
import smart4 from "../../assets/smart4.png";
import producteBg from "../../assets/producteBg.png";
import more from "../../assets/more.png";
import circle from "../../assets/circle.png";
import circleChoose from "../../assets/circleChoose.png";
import wisa from "../../assets/wisa.png";
import wisb from "../../assets/wisb.png";
import wisc from "../../assets/wisc.png";
import wisd from "../../assets/wisd.png";
import wise from "../../assets/wise.png";
import wisf from "../../assets/wisf.png";
import wisg from "../../assets/wisg.png";
import wish from "../../assets/wish.png";
import downArrow from "../../assets/downArrow.png";
import progressBar from "../../assets/progressBar.png";
import progressBarChoose from "../../assets/progressBarChoose.png";
import map from "../../assets/map.png";
import prevR from "../../assets/prevR.png";
import nextR from "../../assets/nextR.png";
import prevW from "../../assets/prevW.png";
import nextW from "../../assets/nextW.png";
import business from "../../assets/business.png";
import heart from "../../assets/heart.png";
import fax from "../../assets/fax.png";
import place from "../../assets/place.png";
import phone from "../../assets/phone.png";
import logoW from "../../assets/logoW.png";
import redBoxa from "../../assets/redBoxa.png";
image: require("../../assets/redBoxa.png");
import redBoxb from "../../assets/redBoxb.png";
import redBoxc from "../../assets/redBoxc.png";
import floor from "../../assets/floor.png";
import bannerMiddle from "../../assets/bannerMiddle.png";
import bannerMin from "../../assets/bannerMin.png";
// import footerVue from '../../layout/footer.vue';
export default {
  name: "home",
  components: {
    Navbar,
    Root,
  },
  data() {
    return {
      index: "",
      page: 1,
      current: 0,
      newspage: 1,
      newsArr: [],
      newArr: [],
      wisList: [
        {
          wisIndex: 1,
          title: "智慧医疗",
          text: "以患者为中心",
          circle: require("../../assets/circle.png"),
          circleChoose: require("../../assets/circleChoose.png"),
          downArrow: require("../../assets/downArrow.png"),
          wisW: require("../../assets/wisa.png"),
          wisR: require("../../assets/wise.png"),
          progressBar: require("../../assets/progressBar.png"),
          progressBarChoose: require("../../assets/progressBarChoose.png"),

          hidden: true,
        },
        {
          wisIndex: 2,
          title: "智慧运营管理",
          text: "以财务管理为核心",
          circle: require("../../assets/circle.png"),
          circleChoose: require("../../assets/circleChoose.png"),
          downArrow: require("../../assets/downArrow.png"),
          wisW: require("../../assets/wisb.png"),
          wisR: require("../../assets/wisf.png"),
          progressBar: require("../../assets/progressBar.png"),
          progressBarChoose: require("../../assets/progressBarChoose.png"),
          hidden: false,
        },
        {
          wisIndex: 3,
          title: "智慧服务",
          text: "全面提升服务质量",
          circle: require("../../assets/circle.png"),
          circleChoose: require("../../assets/circleChoose.png"),
          downArrow: require("../../assets/downArrow.png"),
          wisW: require("../../assets/wisc.png"),
          wisR: require("../../assets/wisg.png"),
          progressBar: require("../../assets/progressBar.png"),
          progressBarChoose: require("../../assets/progressBarChoose.png"),
          hidden: false,
        },
        {
          wisIndex: 4,
          title: "智慧互联",
          text: "实现医疗卫生可持续发展",
          circle: require("../../assets/circle.png"),
          circleChoose: require("../../assets/circleChoose.png"),
          downArrow: require("../../assets/downArrow.png"),
          wisW: require("../../assets/wisd.png"),
          wisR: require("../../assets/wish.png"),
          // progressBar: require("../../assets/progressBar.png"),
          hidden: false,
        },
      ],
      mounted() {
        // this.list[0].hidden = true;
      },
      // newsArr: [
      //   {
      //     index: 1,
      newArr: [
        {
          date: "2020年",
          content: "展华科技作为天津市和平区招商引资重点企业，立足天津面向全国",
        },
        {
          date: "2012年",
          content:
            "展华科技拓展了天津、北京、黑龙江、吉林、新疆、青海、广东等医疗卫生信息化市场",
        },
        {
          date: "2009年",
          content: "展华科技与微软公司医疗软件事业部达成战略合作伙伴协议",
        },
      ],
      //   },
      //   {
      //     index: 2,
      //     newArr: [
      //       {
      //         date: "2012年",
      //         content:
      //           "展华科技拓展了天津、北京、黑龙江、吉林、新疆、青海、广东等医疗卫生信息化市场",
      //       },
      //       {
      //         date: "2020年",
      //         content:
      //           "展华科技作为天津市和平区招商引资重点企业，立足天津面向全国",
      //       },
      //       {
      //         date: "2009年",
      //         content: "展华科技与微软公司医疗软件事业部达成战略合作伙伴协议",
      //       },
      //     ],
      //   },
      // ],
      traitArr: [
        {
          title: "实用型解决方案",
          // url: require("../../assets/redBoxa.png"),
          text: "通过技术创新和实践经验的完美结合，展华科技现已发展成为掌握医疗信息核心技术并获得了众多相关自主知识产权的公司。",
        },
        {
          title: "集成化医疗信息产品",
          // url: require("../../assets/redBoxb.png"),
          text: "展华科技为医疗行业用户提供一系列安全、可靠、高质量、易实施、易扩展的集成化医疗信息产品。",
        },
        {
          title: "自主创新专业品质",
          // url: require("../../assets/redBoxc.png"),
          text: "展华科技以医疗行业用户获得最佳的产品应用体验和持续发展为己任，力争创造客户、社会价值的最大化。",
        },
      ],
      logo: logo,
      worldIcon: worldIcon,
      englishBg: englishBg,
      productBg: productBg,
      ellipse: ellipse,
      coreProducta: coreProducta,
      coreProductb: coreProductb,
      bannerMiddle: bannerMiddle,
      // bannerMin: bannerMin,
      banner: banner,
      smart: smart,
      smart1: smart1,
      smart2: smart2,
      smart3: smart3,
      smart4: smart4,
      producteBg: producteBg,
      more: more,
      circle: circle,
      circleChoose: circleChoose,
      wisa: wisa,
      wisb: wisb,
      wisc: wisc,
      wisd: wisd,
      wise: wise,
      wisf: wisf,
      wisg: wisg,
      wish: wish,
      nextR: nextR,
      prevR: prevR,
      nextW: nextW,
      prevW: prevW,
      downArrow: downArrow,
      progressBar: progressBar,
      progressBarChoose: progressBarChoose,
      map: map,
      heart: heart,
      business: business,
      place: place,
      fax: fax,
      logoW: logoW,
      phone: phone,
      redBoxa: redBoxa,
      redBoxb: redBoxb,
      redBoxc: redBoxc,
      floor,
      floor,
    };
  },
  methods: {
    tab(index) {
      this.page = index;
    },
    news(index) {
      this.newspage = index;
    },
    // news(index) {
    //   this.newspage = index;
    // },
    isActive(wisIndex) {
      this.current = wisIndex;
      // console.log(this.current)
    },
    goProductCenter() {
      this.$router.push({ path: "productCenter" });
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 1920px) {
  .header-banner {
    background: url("../../assets/banner.png") no-repeat;
    background-size: cover;
    background-position: center;
  }
}
@media screen and (min-width: 1600px) and (max-width: 1920px) {
  .header-banner {
    background: url("../../assets/bannerMiddle.png") no-repeat;
    background-size: cover;
    background-position: center;
  }
}
@media screen and (max-width: 1600px) {
  .header-banner {
    background: url("../../assets/bannerMin.png") no-repeat;
    background-size: cover;
    background-position: center;
  }
}
footer {
  height: 520px;
  margin-top: 30px;
}
header {
  background-color: #ffffff;
}
.home-header {
  height: 940px;
}
.header-banner {
  height: 700px;
  position: relative;
  margin-bottom: 100px;
}
body {
  margin: 0 !important;
  margin: 0;
}
.index {
  background-color: #60656b;
  overflow: hidden;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  /* position: relative; */
}

/* .banner-swiper {
  width: 1920px;
  height: 940px;
  position: relative;
  overflow: hidden; */
/* }
.el-carousel__item {
  height: 700px;
}
.el-image {
  height: 700px;
} */
.top {
  position: absolute;
  width: 85%;
  height: 220px;
  z-index: 3;
  left: 7.5%;
  top: 636px;
  display: flex;
  justify-content: space-around;
  background-color: #ffffff;
}
.topText {
  text-align: center;
}
.topText p:nth-child(1) {
  font-size: 60px;
  margin: 0 !important;
  padding-top: 50px;
  color: #f63a1f;
  letter-spacing: 0;
  font-weight: 700;
}
.topText p:nth-child(1) span {
  font-family: PingFangSC-Regular;
  font-size: 20px;
  color: #f63a1f;
  letter-spacing: 0;
  font-weight: 400;
}
.topText p:nth-child(2) {
  font-family: PingFangSC-Regular;
  margin: 0 !important;
  padding-top: 18px;
  font-size: 20px;
  color: #8c90a0;
  letter-spacing: 0;
  /* line-height: 20px; */
  font-weight: 400;
}

.productBox {
  width: 100%;
  margin: 0 auto;
  padding-top: 100px;
  position: relative;
  height: 584px;
  background-color: #ffffff;
}
.productContentBg {
  width: 85%;
  position: absolute;
  text-align: center;
  left: 7.5%;
  top: 177px;
}
.englishBg {
  width: 85%;
  margin: 0 auto;
  text-align: center;
  height: 151px;
  left: 7.5%;
}
.englishBg img {
  height: 151px;
  width: 100%;
}

.productTitle {
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 40px;
  height: 56px;
  color: #111829;
  letter-spacing: 0;
  font-weight: 500;
}
.productText {
  width: 40px;
  height: 40px;
  margin: 0 auto;
}
.productContent {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #8c90a0;
  letter-spacing: 0;
  /* height: 300px; */
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  margin-top: 17px;
}
.productContentBox {
  width: 85%;
  margin: 0 auto;
  display: flex;
  margin-top: 140px;
  justify-content: space-between;
}
.productContentBox .redBoxBacklist {
  width: 25%;
}
.productContentBox .redBoxBacklist:nth-child(1) .redBoxBack {
  background: url("../../assets/redBoxa.png") no-repeat;
  background-position: right top;
}
.productContentBox .redBoxBacklist:nth-child(2) .redBoxBack {
  background: url("../../assets/redBoxb.png") no-repeat;
  background-position: right top;
}
.productContentBox .redBoxBacklist:nth-child(3) .redBoxBack {
  background: url("../../assets/redBoxc.png") no-repeat;
  background-position: right top;
}
.redTitleBox {
  display: flex;
}
.redline {
  width: 8px;
  height: 30px;
  background-color: red;
}
.redTitle {
  font-family: PingFangSC-Medium;
  font-size: 18px;
  color: #f63a1f;
  letter-spacing: 0;
  text-align: left;
  font-weight: 500;
  margin-left: 10px;
}
/* .redTitle img{
  margin-left: 63px;
} */
/* .redBoxBack {
  width: 70%;
} */
.tecText {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
  margin-top: 10px;
}
.coreProductBg {
  width: 100%;
  display: flex;
  position: absolute;
}
.coreProduct {
  width: 100%;
  overflow: hidden;
  height: 750px;
  position: relative;
  background: url("../../assets/protuceBg.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.a {
  margin: 0 auto;
  width: 85%;
  display: flex;
  margin-top: 100px;
}
.coreProductTitle {
  display: flex;
  line-height: 40px;
  font-family: PingFangSC-Medium;
  font-size: 36px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
.whiteLine {
  width: 8px;
  background-color: #ffffff;
  height: 40px;
  margin-right: 16px;
}

.coreProductContent {
  display: flex;
}
.coreProductContent img {
  width: 35px;
  height: 35px;
}
.coreProductContent p {
  margin-left: 10px;
}
.coreProductText p:nth-child(1) {
  margin-top: 55px;
  color: #ffffff;
  font-size: 20px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 26px;
  font-weight: 500;
  margin-bottom: 15px;
}
.coreProductContent {
  margin-top: 27px;
}
.coreProductContentP {
  margin-left: -17px;
  font-size: 18px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
  margin-top: 7px;
}
.coreProduct-c {
  width: 350px;
  height: 350px;
  background-color: #ffffff;
  top: 300px;
  position: absolute;
  /* top: 0; */
  left: 35%;
  z-index: 5;
}
.coreProduct-cTitle {
  font-family: Fontquan-XinYiGuanHeiTi2.0-Regular;
  font-size: 40px;
  color: #f63a1f;
  margin: 0 auto;
  margin-left: 46px;
  letter-spacing: 0;
  font-weight: 400;
}
.redLine {
  margin: 0 auto;
  margin-left: 46px;
  width: 30px;
  height: 6px;
  margin-top: 50px;
  background-color: #f63a1f;
  margin-bottom: 20px;
}
.coreProduct-cText {
  width: 75%;
  margin: 0 auto;
  font-family: PingFangSC-Light;
  font-size: 16px;
  color: #3d455f;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
  font-weight: 200;
}
.coreProduct-swiper {
  display: flex;
  position: absolute;
  top: 106px;
  left: 45%;
  z-index: 3;
}
.core-swiper {
  position: absolute;
  top: 600px;
  left: 85%;
}
.smartBox {
  width: 100%;
  margin: 0 auto;
  padding-top: 120px;
  position: relative;
  background-color: #ffffff;
}
.smartContentBg {
  width: 85%;
  position: absolute;
  text-align: center;
  left: 7.5%;
  top: 197px;
}
.englishBg {
  width: 85%;
  margin: 0 auto;
  text-align: center;
  height: 151px;
  left: 7.5%;
}
.englishBg img {
  height: 151px;
  width: 100%;
}
.smartTitle {
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 40px;
  height: 56px;
  color: #111829;
  letter-spacing: 0;
  font-weight: 500;
}
.smartText {
  width: 40px;
  height: 40px;
  margin: 0 auto;
}
.smartContent {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #8c90a0;
  letter-spacing: 0;
  /* height: 300px; */
  text-align: center;
  line-height: 28px;
  font-weight: 400;
  margin-top: 15px;
}
.smartContentBox {
  width: 85%;
  margin: 0 auto;
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}
.smartFooter {
  display: flex;
  width: 85%;
  margin: 0 auto;
  margin-top: 80px;
  height: 300px;
  justify-content: space-between;
}
.smartImg {
  font-size: 22px;
  color: #f63a1f;
  letter-spacing: 0;
  font-weight: 500;
  text-align: center;
}
.smartImg :nth-child(2) {
  margin-top: 30px;
}
.smartImg img {
  width: 90px;
  height: 90px;
}
.wis {
  position: relative;
  height: 720px;
  overflow: hidden;
  background-color: #ffffff;
  /* margin-bottom: 120px; */
}
.wisBg {
  position: absolute;
  height: 620px !important;
  background: url("../../assets/producteBg.png") no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
}
.wisCont {
  width: 85%;
  margin: 0 auto;
}
.wisContTitle {
  display: flex;
  font-size: 36px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 69px;
  position: relative;
  line-height: 36px;
}

.wisContMore {
  cursor: pointer;
  font-size: 16px;
  top: 0;
  right: 0;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 200;
  position: absolute;
}
.wisText {
  display: flex;
  /* position: absolute; */
  margin: 0 auto;
  width: 85%;
  text-align: center;
  /* background-color: pink; */
  justify-content: center;
}

.wisblock {
  font-size: 22px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 70px;
}
.wisText-l {
  /* background-color: powderblue; */
  width: 100%;
  text-align: center;
  /* justify-content: center; */
}
.wisText-l :nth-child(2) {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
  /* margin-top: 7px; */
}
.circle {
  /* position: relative; */
  margin-top: 30px;
  margin-bottom: 16px;
}
.progressBar {
  position: absolute;
  /* background-color: plum; */
  margin-top: -30px;
}
.progressBar img {
  width: 62%;
  margin-left: 155px;
  margin-top: -30px;
}
.wisa {
  margin-top: 17px;
}
line {
  margin-top: 20px;
}
/* .map img {
  width: 100%;
} */
.mapBg {
  text-align: center;
  width: 100%;
}
.map {
  overflow: hidden;
  position: relative;
  /* width: 1299px; */
  margin: 0 auto;
  margin-top: 40px;
  text-align: center;
}
.information {
  display: flex;
  width: 85%;
  margin: 0 auto;
  margin-top: 74px;
}
.information-l {
  width: 50%;
  background: #f8f9fc;
  height: 660px;
}
.information-ltext {
  width: 90%;
  margin: 0 auto;
  margin-top: 33px;
}
.information-ltext :nth-child(1) {
  margin: 0 auto;
  font-size: 22px;
  color: #111829;
  letter-spacing: 0;
  font-weight: 500;
  margin-top: 33px;
}

.information-ltext :nth-child(2) {
  font-size: 16px;
  color: #8c90a0;
  letter-spacing: 0;
  line-height: 28px;
  font-weight: 400;
  margin-top: 30px;
}
.information-l img {
  width: 100%;
  height: 412px;
}
.information-r {
  width: 50%;
  height: 660px;
  margin-left: 120px;
}
.information-rtitle {
  font-size: 18px;
  color: #3d455f;
  letter-spacing: 0;
  font-weight: 400;
}
.information-rtext {
  margin-top: 30px;
  font-size: 28px;
  height: 100px;
  color: #111829;
  letter-spacing: 0;
  font-weight: 400;
  border-bottom: 1px #e9eaee solid;
}
.information-rlist {
  height: 200px;
}
.information-rfoot {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue